<app-modal [withBox]="true" (modalClose)="modalClose.emit(LeaveModalAction.Close)">
    <h2 class="leaving-site-title">You are leaving this website</h2>
    <p class="modal__copy">You are about to leave the <b>Screen for EPI in CP</b> website and connect to a website that is not under the control of AbbVie.</p>
    <p class="modal__copy"><b>Are you happy to continue?</b></p>
    <div class="horizontal-block">
        <a href="{{url}}" target="_blank" (click)="modalClose.emit(LeaveModalAction.Yes)">
            <app-button text="Yes"></app-button>
        </a>
        <p *ngIf="!continueLabel; else continueLabel">Continue to {{url}} (Opens in a new tab)</p>
        <ng-template #continueLabel>
            <p>{{ continueLabelString }}</p>
        </ng-template>
    </div>
    <div class="horizontal-block">
        <a>
            <app-button text="No" (btnClick)="modalClose.emit(LeaveModalAction.No)"></app-button>
        </a>
        <p>Return to https://screenforepiincp.com</p>
    </div>
</app-modal>